import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import dayjs from 'dayjs';
import { getPriceForAmount, toDateHRDate } from "../helpers";
import Image from "./Image";
import { ImageSizes } from "../theme";
import { NBSP, PRODUCT_NAME_TEST_ID } from "../constants";
import Box from "../../Grid/Box";
import Price, { OldPrice } from "./Price";
import { EnumProductStates, EnumProductType } from "../types";
import { ProductName } from "./Name";
import { RelativeBox, ImageWrapper } from "../styled";
import { numberToFormattedCurrencyString } from "../../QuantityControls/helpers";
var OldPriceStyled = styled(OldPrice).withConfig({
  displayName: "GridCardProductInfo__OldPriceStyled",
  componentId: "sc-145a9fb-0"
})(["position:absolute;transform:translateY(-100%);padding:4px 24px 0 0;background-size:cover;background-position:right bottom;background-repeat:no-repeat;background-image:url(", ");"], function (_ref) {
  var saleBack = _ref.theme.saleBack;
  return saleBack;
});

var GridCardProductInfo = function GridCardProductInfo(_ref2) {
  var _product$image;

  var product = _ref2.product,
      state = _ref2.state,
      fullImage = _ref2.fullImage;
  var isQuantityWeight = product.type === EnumProductType.weight;
  var isPriceApproximate = product.amount > 0 && product.type === EnumProductType.pack;

  var _useContext = useContext(ThemeContext),
      priceSign = _useContext.priceSign;

  var regularPrice = isQuantityWeight ? getPriceForAmount(product.price_per_kg, product.weight / 1000) : getPriceForAmount(product.price, product.amount);
  var oldPrice = product.old_price && (isQuantityWeight ? getPriceForAmount(product.old_price, product.weight / 1000) : getPriceForAmount(product.old_price, product.amount));
  var isNotAvailable = state === EnumProductStates.notAvailable || !product.available;
  return React.createElement(React.Fragment, null, React.createElement(ImageWrapper, {
    withFullImage: fullImage
  }, React.createElement(Image, {
    size: fullImage ? ImageSizes.full : ImageSizes.big,
    src: (_product$image = product.image) === null || _product$image === void 0 ? void 0 : _product$image.medium,
    disabled: isNotAvailable
  })), React.createElement(RelativeBox, null, !isNotAvailable && oldPrice && React.createElement(OldPriceStyled, null, React.createElement("s", null, numberToFormattedCurrencyString(oldPrice), NBSP, priceSign, NBSP), product.sale_end_date && dayjs().isBefore(product.sale_end_date) && "".concat(NBSP, "\u0434\u043E").concat(NBSP).concat(toDateHRDate(product.sale_end_date)))), React.createElement(Box, {
    mt: isNotAvailable ? 3 : 0,
    mb: isNotAvailable ? 2 : 0,
    mtXs: isNotAvailable ? 2.5 : 0
  }, React.createElement(Price, {
    price: regularPrice,
    disabled: isNotAvailable,
    sale: product.sale,
    approximate: isPriceApproximate
  })), React.createElement(Box, {
    mt: 1
  }, React.createElement(ProductName, {
    "data-testid": PRODUCT_NAME_TEST_ID
  }, product.name)));
};

export default GridCardProductInfo;